import React from 'react'
import { Link } from 'react-router-dom'
import ClientLoginLayout from 'spa/client/layouts/ClientLoginLayout'
import CSSModules from 'react-css-modules'
import styles from './style.module.scss'

const ErrorPage: React.FC = () => {
  return (
    <ClientLoginLayout>
      <div styleName='error-page'>
        <div styleName='content'>
          <h1>404 Not Found</h1>
          <p styleName='description'>
            お探しのページは見つかりませんでした。<br />
            一時的にアクセスができないか、移動または削除された可能性があります。<br />
            URLが正しく入力されているかご確認ください。
          </p>
          <div styleName='anchor'>
            <Link to='/clients/home'>トップに戻る</Link>
          </div>
        </div>
      </div>
    </ClientLoginLayout>
  )
}

export default CSSModules<React.FC>(ErrorPage, styles)
